import React from "react";
import {
  SiReact,
  SiNodedotjs,
  SiPython,
  SiJavascript,
  SiDocker,
  SiAmazonwebservices,
  SiMongodb,
  SiMysql,
  SiGooglecloud,
  SiTensorflow,
  SiTailwindcss,
  SiGraphql,
  SiRedis,
  SiPostgresql,
  SiExpress,
  SiFigma,
  SiGithub,
  SiTypescript,
  SiVuedotjs,
  SiPhp,
} from "react-icons/si";
import { FiCpu, FiZap } from "react-icons/fi";

const ITEMS = [
  { label: "React",            Icon: SiReact,             color: "#61DAFB" },
  { label: "Node.js",          Icon: SiNodedotjs,         color: "#8CC84B" },
  { label: "Python",           Icon: SiPython,            color: "#3776AB" },
  { label: "TypeScript",       Icon: SiTypescript,        color: "#3178C6" },
  { label: "AWS",              Icon: SiAmazonwebservices, color: "#FF9900" },
  { label: "Docker",           Icon: SiDocker,            color: "#2496ED" },
  { label: "MongoDB",          Icon: SiMongodb,           color: "#47A248" },
  { label: "MySQL",            Icon: SiMysql,             color: "#4479A1" },
  { label: "Google Cloud",     Icon: SiGooglecloud,       color: "#4285F4" },
  { label: "TensorFlow",       Icon: SiTensorflow,        color: "#FF6F00" },
  { label: "Tailwind CSS",     Icon: SiTailwindcss,       color: "#06B6D4" },
  { label: "GraphQL",          Icon: SiGraphql,           color: "#E10098" },
  { label: "Redis",            Icon: SiRedis,             color: "#DC382D" },
  { label: "PostgreSQL",       Icon: SiPostgresql,        color: "#4169E1" },
  { label: "JavaScript",       Icon: SiJavascript,        color: "#F7DF1E" },
  { label: "Express.js",       Icon: SiExpress,           color: "#CCCCCC" },
  { label: "Figma",            Icon: SiFigma,             color: "#F24E1E" },
  { label: "Machine Learning", Icon: FiCpu,               color: "#34D399" },
  { label: "Git & GitHub",     Icon: SiGithub,            color: "#AAAAAA" },
  { label: "Vue.js",           Icon: SiVuedotjs,          color: "#42B883" },
  { label: "PHP",              Icon: SiPhp,               color: "#777BB4" },
  { label: "CI / CD",          Icon: FiZap,               color: "#FBBF24" },
];

const TechMarquee = () => (
  <div className="tech-marquee-section" aria-hidden="true" role="presentation">
    <div className="tech-marquee-track">
      {/* Duplicate for seamless infinite loop */}
      {[...ITEMS, ...ITEMS].map(({ label, Icon, color }, i) => (
        <span key={i} className="tech-marquee-item">
          <Icon style={{ color }} aria-hidden="true" />
          {label}
        </span>
      ))}
    </div>
  </div>
);

export default TechMarquee;
